import { useState, useEffect } from "react";
import { ChevronRight } from "lucide-react";
import { apiService } from "../utils/api";
import { Footer } from "../components/shared/Footer";

const PlutoGuidePage = () => {
  const [guide, setGuide] = useState({});
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiService.getPlutoGuide();
        setGuide(response.data.guide);
        setCategories(response.data.categories);
        setLoading(false);
      } catch (error) {
        console.error('Error:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-44 px-4 md:px-12" data-testid="pluto-guide-page">
      <div className="mb-8">
        <div className="flex items-center gap-4 mb-2">
          <h1 className="text-3xl font-bold text-white">Watch on Pluto.tv</h1>
          <span className="bg-blue-600 text-white px-3 py-1 rounded text-sm font-medium">FREE</span>
        </div>
        <p className="text-gray-400">Discover free streaming content on Pluto.tv - Click any channel to watch</p>
        <p className="text-gray-500 text-sm mt-1">Note: Links open Pluto.tv in a new tab</p>
      </div>

      {loading ? (
        <div className="text-center text-gray-400 py-20">Loading...</div>
      ) : (
        categories.map(category => (
          <div key={category} className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <span className="text-2xl">{guide[category]?.[0]?.logo}</span>
              {category}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {guide[category]?.map(item => (
                <a
                  key={item.id}
                  href={item.pluto_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gray-900 rounded-lg p-4 hover:bg-gray-800 transition-colors group border border-gray-800 hover:border-blue-600"
                >
                  <div className="text-4xl mb-3">{item.logo}</div>
                  <h3 className="text-white font-medium mb-1 group-hover:text-blue-400">{item.name}</h3>
                  <p className="text-gray-500 text-xs">{item.description}</p>
                  <div className="mt-3 text-blue-500 text-sm flex items-center gap-1">
                    Watch Free
                    <ChevronRight size={14} />
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))
      )}

      <div className="bg-blue-900/30 border border-blue-800 rounded-xl p-6 mb-8">
        <h3 className="text-white font-bold mb-2">About Pluto.tv</h3>
        <p className="text-gray-300 text-sm mb-4">
          Pluto.tv is a free, ad-supported streaming service offering 250+ live TV channels and thousands of movies. 
          No subscription required - just click and watch!
        </p>
        <a 
          href="https://pluto.tv"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium"
        >
          Visit Pluto.tv →
        </a>
      </div>

      <Footer />
    </div>
  );
};

export default PlutoGuidePage;
